import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { register } from '../../components/services/server-api/api';
import { useLoading  } from '../../components/services/check_login';


const Register = () => {
    const { showLoading, hideLoading } = useLoading();
  const [credentials, setCredentials] = useState({
    username: '',
    firstName:'',
    lastName:'',
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    showLoading();
    try {
      await register(credentials);
      navigate('/');
      hideLoading();
    } catch (err) {
        hideLoading();
      setError(err.response?.data?.message || 'Registration failed');
    }
  };

  return (
    <div>
      <h2>Register</h2>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      <form onSubmit={handleSubmit}>
        <input
          name="username"
          placeholder="Username"
          value={credentials.username}
          onChange={handleChange}
          required
        />
          <input
          name="firstName"
          placeholder="First Name"
          value={credentials.firstName}
          onChange={handleChange}
          required
        />
          <input
          name="lastName"
          placeholder="Last Name"
          value={credentials.lastName}
          onChange={handleChange}
          required
        />
        <input
          name="email"
          placeholder="Email"
          type="email"
          value={credentials.email}
          onChange={handleChange}
          required
        />
        <input
          name="password"
          placeholder="Password"
          type="password"
          value={credentials.password}
          onChange={handleChange}
          required
        />
        <button type="submit">Register</button>
      </form>
    </div>
  );
};

export default Register;
